module.exports = __webpack_public_path__ + "static/assets/e5c5db78296aa8925658d43f53598198.svg";